import { File, Maximize2, Minimize2, Search, X } from 'lucide-react';

export function SearchIcon() {
  return <Search size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}

export function ShrinkIcon() {
  return <Minimize2 size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}

export function ExpandIcon() {
  return <Maximize2 size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}

export function CloseIcon() {
  return <X size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}

export function FilesIcon() {
  return <File size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}
